export default __webpack_public_path__ + "7fc67c35a51ea035000769314dee8bf0.png";